<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
      v-if="isShow"
    >
      <el-form-item label="选择品牌:" prop="inputList">
        <carSearch
          @increment="appAddCounter"
          :inputList.sync="row"
          :searchType="1"
        ></carSearch>
      </el-form-item>

      <el-form-item label="团购名称:" prop="group_name">
        <el-input v-model="form.group_name"></el-input>
      </el-form-item>

      <el-form-item label="活动主画面:" prop="group_logo">
        <uploadImage
          @setImgFun="getImgUrl"
          :fileListArr="group_logo"
        ></uploadImage>
      </el-form-item>

      <el-form-item label="团购地点:">
        <el-input v-model="form.group_addr"></el-input>
      </el-form-item>

      <el-form-item label="团购价格:">
        <el-input v-model="form.group_price"></el-input>
      </el-form-item>

      <el-form-item label="团购时间:" prop="timeArr">
        <el-date-picker
          v-model="timeArr"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          :default-time="['12:00:00']"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="热门团购:" prop="group_hot">
        <el-radio-group v-model="form.group_hot">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="团购政策:" prop="group_policy">
        <editor
          @emitedit="appAddGroup"
          :activitiesCon="group_policy"
        ></editor>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editor from "../../components/editor/editor";
import carSearch from "../../components/car-search/car-search";
import uploadImage from "../../components/upload-image/upload-image";
import {AllEdit} from "../../api/api"
export default {
  components: {
    carSearch,
    editor,
    uploadImage,
  },
  name: "car-group-form",
  props: {
    layerid: String,
    edit: Boolean,
    keyword: Array,
    row: {
      default: function () {
        return [];
      },
    },
    types: Array,
  },
  data() {
    var inputListChange = (rule, value, callback) => {
      if (typeof this.form.brandid == "undefined" || this.form.brandid == "") {
        callback(new Error("请选择品牌"));
      } else {
        callback();
      }
    };

    let data = {
      bt: "创建",
      uploadUrl: "file-upload-set", //文件上传url
      fileList: [], //文件上传列表
      form: {},
      loading: true,
      inputList: [],
      rules: {
        inputList: [
          { validator: inputListChange, required: true, trigger: "blur" },
        ],
        group_name: [
          { required: true, message: "请输入团购名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      timeArr: [],
      optionBrand: [],
      listSearch: [],
      where: {
        brand_name: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      group_policy: "",
      isShow:false,
      group_logo:""
    };
    return data;
  },
  async mounted() {
    if (this.edit) {
      let msg = await AllEdit("api/car-group/" + this.row.id);
      let {data} = msg;
      data = JSON.parse(data).data;
      this.form = data;
      console.log("编辑数据",data)
      this.timeArr.push(data.group_start_time);
      this.timeArr.push(data.group_end_time);
      this.group_logo = this.form.group_logo
      this.isShow = true;
      this.loading = false;
    }else{
      this.isShow = true;
      this.loading = false;
    }
  },
  methods: {
    onSubmit(e) {
      this.form.group_start_time =
        this.timeArr == null ? "" : this.dateConversion(this.timeArr[0]);
      this.form.group_end_time =
        this.timeArr == null ? "" : this.dateConversion(this.timeArr[1]);
      let data = this.form;
      if(data.group_logo == null || data.group_logo == ""){
        return this.$message.error("团购封面需要您上传")
      }
      this.$refs[e].validate((valid) => {
        if (valid) {
          this.$emit("emitcargroup",{form:data})
        } else {
          this.$message.error("请您检查表单完整性");
          return false;
        }
      });
    },
    close() {
        this.$emit("emitcargroup",{})
    },
    dateConversion(timestamp) {
      if (timestamp == "" || typeof timestamp == "undefined") return "";
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // console.log()
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();

      function addZero(val) {
        return val < 10 ? "0" + val : val;
      }
      return (
        Y +
        "-" +
        addZero(M) +
        "-" +
        addZero(D) +
        " " +
        addZero(h) +
        ":" +
        addZero(m) +
        ":" +
        addZero(s)
      );
    },
    appAddCounter: function (e) {
      this.form.brandid = e["brandid"];
    },
    appAddGroup: function (e) {
      this.form.group_policy = e;
    },
    getImgUrl(e) {
      this.form.group_logo = JSON.stringify(e); //上传文件列表
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>

